export default __webpack_public_path__ + "static/media/contact-img.e8fc4943.png";